<template>
  <el-dialog
      title="认定意见"
      :visible.sync="dialogVisible"
      width="800px"
      append-to-body
      :before-close="handleClose"
      class="opinion-dialog"
  >
    <div class="opinion">
      <div class="section-block">
        <div class="section-title">认定条款</div>

        <el-form :model="form" ref="form"  label-width="120px" :rules="rules" class="section-form clause-form">
          <el-form-item label-width="0px" prop="identificationClauseCode">
            <div class="clause-wrapper">
              <div v-if="legalClauseLoading" class="clause-loading">正在加载法定条款...</div>
              <template v-else>
                <el-radio-group v-if="legalClauseOptions.length" v-model="form.identificationClauseCode"
                                class="clause-group">
                  <!--              <el-row :gutter="24">-->
                  <!--                <el-col-->
                  <!--                    v-for="item in legalClauseOptions"-->
                  <!--                    :key="item.dictValue"-->
                  <!--                    :span="12"-->
                  <!--                    class="clause-col"-->
                  <!--                >-->
                  <el-radio v-for="item in legalClauseOptions"
                            :key="item.dictValue" :label="String(item.dictValue)" class="clause-checkbox">
                    <span class="clause-text">{{ item.dictLabel }}</span>
                  </el-radio>
                  <!--                </el-col>-->
                  <!--              </el-row>-->
                </el-radio-group>
                <div v-else class="clause-empty">暂无法定条款数据</div>
              </template>
            </div>
          </el-form-item>
          <el-form-item label="条款类型">
            <el-input
                :value="clauseDecisionText"
                placeholder="请先选择法定条款"
                disabled
            />
          </el-form-item>
          <el-form-item label="认定日期" prop="identificationDate">
            <el-date-picker
                v-model="form.identificationDate"
                type="date"
                placeholder="请选择认定日期"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
            />
          </el-form-item>
          <!-- 选中「放弃」时展示 -->
          <template v-if="form.identificationClauseCode==15">
            <el-form-item label="放弃类型">
              <el-select
                  v-model="form.abandonTypeCode"
                  placeholder="请选择放弃类型"
                  clearable
                  style="width: 100%;"
              >
                <el-option
                    v-for="item in abandonTypeOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="放弃时间">
              <el-date-picker
                  v-model="form.abandonDate"
                  type="date"
                  placeholder="请选择放弃时间"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
              />
            </el-form-item>
<!--            <el-form-item v-if="showAbandonReason" label="放弃原因">-->
<!--              <el-input-->
<!--                  v-model="form.abandonReason"-->
<!--                  type="textarea"-->
<!--                  :rows="3"-->
<!--                  placeholder="请输入放弃原因"-->
<!--                  resize="vertical"-->
<!--              />-->
<!--            </el-form-item>-->
            <el-form-item label="被告人">
              <el-input
                  v-model="form.beAnnouncedName"
                  placeholder="请输入被告人"
                  clearable
              />
            </el-form-item>
          </template>
        </el-form>
      </div>

      <div class="section-block">
        <div class="section-title">调查核实情况</div>
        <el-form :model="form" label-width="120px" class="section-form">
          <el-form-item label="调查核实情况">
            <el-input
                v-model="form.examineTheSituation"
                type="textarea"
                :rows="4"
                placeholder="请输入调查核实情况"
                resize="vertical"
            />
          </el-form-item>
        </el-form>
      </div>


    </div>
    <div slot="footer">
      <el-button  plain @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit">提交认定结果</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {getListByDictType} from '@/api/sys/dictData'
import {getDetermineOpinion,updateDetermineOpinion,getDetermineDetail} from '@/api/recognition/determine'

export default {
  name: 'RecognitionOpinion',
  props: {
    isDialog: {
      type: Boolean,
      default: false
    },
    caseId: {
      type: [String, Number],
      default: ''
    },
    type:{
      type:Number,
      default:1
    }
  },
  data() {
    return {
      form: {
        identificationClauseCode: '',
        caseSummary: '',
        difficultPoints: '',
        identificationDate: '',
        reviewOpinion: '',
        examineTheSituation: '',
        accidentConclusion: '',
        abandonTypeCode: '',
        abandonDate: '',
        abandonReason: '',
        beAnnouncedName: ''
      },
      legalClauseOptions: [],
      legalClauseLoading: false,
      abandonTypeOptions: [],
      rules:{
        identificationClauseCode:[
            {required:true,message:'请选择认定条款',trigger:'blur'}
        ],
        identificationDate: [
          {required:true,message:'请选择认定日期',trigger:'blur'}
        ]
      }
    }
  },
  created() {
    this.fetchLegalClauseOptions()
    this.fetchAbandonTypeOptions()
  },
  watch:{
    'form.identificationClauseCode'(newVal){
      if(newVal!=15){
        this.form.abandonTypeCode = ''
        this.form.abandonDate = ''
        this.form.beAnnouncedName = ''
      }
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isDialog
      },
      set() {
        this.handleClose()
      }
    },
    // 条款类型：多选时优先级 放弃 > 不予认定为工伤 > 予以视同为工伤(8-10) > 予以认定为工伤(1-7)
    clauseDecisionText() {
      let obj=[
        {
          name:'予以认定为工伤',
          value:[1,2,3,4,5,6,7]
        },
        {
          name:'予以视同为工伤',
          value: [8,9,10]
        },{
          name:'不予认定为工伤',
          value:[11,12,13,14]
        },
        {
          name:'撤销',
          value:[15]
        }
      ]
      let text = ''
      obj.forEach(item => {
        if (item.value.some(val => this.form.identificationClauseCode.includes(val))) {
          text = item.name
        }
      })
      return text
    },
    isAbandonSelected() {
      if (!this.form.legalClauses || !this.form.legalClauses.length) return false
      const selected = this.form.legalClauses.map((val) => String(val))
      return this.legalClauseOptions.some(
          (item) => selected.includes(String(item.dictValue)) && String(item.dictLabel || '').trim() === '放弃'
      )
    },

  },
  methods: {
    handleCancel(){
      this.handleClose()
    },
    async fetchLegalClauseOptions() {
      this.legalClauseLoading = true
      try {
        const res = await getListByDictType('industrial_injury_recognition_clause_type')
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.legalClauseOptions = res.data
        } else {
          this.legalClauseOptions = []
        }
      } catch (error) {
        console.warn('法定条款数据加载失败', error)
        this.legalClauseOptions = []
      } finally {
        this.legalClauseLoading = false
      }
    },
    async fetchAbandonTypeOptions() {
      try {
        const res = await getListByDictType('industrial_injury_recognition_abandon_type')
        if (res && res.code === 200 && Array.isArray(res.data)) {
          this.abandonTypeOptions = res.data
        } else {
          this.abandonTypeOptions = []
        }
      } catch (error) {
        console.warn('放弃类型字典加载失败', error)
        this.abandonTypeOptions = []
      }
    },
    handleClose() {
      this.$emit('handleClose')
    },
    handleSave() {
      this.$message.info('保存认定意见（接口待对接）')
    },
    handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            let caseId=this.caseId
            this.form.identificationClauseName = this.selectDictLabel(this.legalClauseOptions,this.form.identificationClauseCode)
            this.form.caseId = caseId
            if(this.type==1){
              getDetermineOpinion(this.form).then(res => {
                if (res && res?.code === 200) {
                  this.$message.success('提交认定')
                  this.handleClose()
                } else {
                  this.$message.error(res.msg || '提交认定失败')
                }
              })
            }else{
              updateDetermineOpinion(this.form).then(res => {
                if (res && res?.code === 200) {
                  this.$message.success('修改认定成功')
                  this.handleClose()
                } else {
                  this.$message.error(res.msg || '修改认定失败')
                }
              })
            }
          }
        })
    },
    getDetail(){
      getDetermineDetail({
        caseId:this.caseId
      }).then(res => {
        if (res && res?.code === 200) {
          this.form = res.data || {}
        } else {
          this.$message.error(res.msg || '获取认定详情失败')
        }
      })
    }
  },
  mounted() {
    if(this.type==2) {
      this.getDetail()
    }
  }
}
</script>

<style lang="scss" scoped>
/* 与 acceptDialog 一致的弹窗头部样式 */
/deep/ .el-dialog__header {
  background: #297dee !important;
}

/deep/ .el-dialog__title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 17px;
}

/deep/ .el-dialog__headerbtn {
  filter: brightness(0) invert(1) !important;
}

.opinion {
  width: 100%;
  height: 60vh;
  overflow-y: auto;
}
/deep/.el-dialog__body{
  padding: 20px 20px;
}

.section-block {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.section-title {
  position: relative;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  padding-left: 11px;
  margin-bottom: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 12px;
    border-radius: 20px;
    background: var(--vt-c-blue);
  }
}

.clause-wrapper {
  padding: 16px 20px;
  border: 1px dashed rgba(41, 125, 238, 0.4);
  border-radius: 6px;
  background-color: #f8fbff;
}

.clause-loading,
.clause-empty {
  font-size: 13px;
  color: #909399;
}

.clause-group {
  width: 100%;
}

.clause-col {
  margin-bottom: 12px;
}

.clause-checkbox {
  width: 100%;
  background: #F7F7F7;
  border-radius: 4px;
  padding: 10px 0px  10px 10px;
  box-sizing: border-box;
  margin-bottom: 12px;
  :deep(.el-checkbox__label) {
    white-space: normal;
    line-height: 20px;
    color: rgba(42, 51, 71, 1);
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
  }
}

.clause-text {
  display: inline-block;
  font-size: 14px;
  word-break: break-all;
  white-space: normal;
}

.clause-form {
  margin-top: 12px;
}

.section-form {
  :deep(.el-form-item__label) {
    color: #2a3347 !important;
    font-weight: 400;
    font-size: 16px;
  }
}

.section-actions {
  padding-bottom: 24px;

  .el-button {
    margin-right: 12px;
  }
}

</style>